// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"808":"a745d377","985":"e4a2691e"}[chunkId] + ".chunk.js";
};